import { render, staticRenderFns } from "./ChatRecord.vue?vue&type=template&id=135bd72c&scoped=true"
import script from "./ChatRecord.vue?vue&type=script&lang=js"
export * from "./ChatRecord.vue?vue&type=script&lang=js"
import style0 from "./ChatRecord.vue?vue&type=style&index=0&id=135bd72c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/lyb/工作/个人/leo——im/新版代码/box-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135bd72c",
  null
  
)

export default component.exports